import { TagInformation } from './tag-information';

export class UnitTaggingRow {

  lineId!: string;
  partNumber!: string;
  lineDescription!: string;
  tagInformation!: TagInformation;

}
